import { render, staticRenderFns } from "./relatedGoodsCell.vue?vue&type=template&id=2a21c7c2&scoped=true"
import script from "./relatedGoodsCell.vue?vue&type=script&lang=js"
export * from "./relatedGoodsCell.vue?vue&type=script&lang=js"
import style0 from "./relatedGoodsCell.vue?vue&type=style&index=0&id=2a21c7c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a21c7c2",
  null
  
)

export default component.exports